// TODO: Migrate tracking utiliities to TS
import {
  trackCdp,
  trackCheckoutClick,
  trackClickFeature,
  trackEvent,
  trackGA,
  trackViewFeature,
} from 'utilities/tracking';
import {
  COMPONENT_NAMES,
  CHECKOUT_STEP_MAP,
  CHECKOUT_PAGE_CLICK_EVENTS,
} from 'typescript/constants/tracking';

type CheckoutStepName =
  (typeof COMPONENT_NAMES.APPS.CHECKOUT_V3)[keyof typeof COMPONENT_NAMES.APPS.CHECKOUT_V3];

type CheckoutPageClickEvent =
  (typeof CHECKOUT_PAGE_CLICK_EVENTS)[keyof typeof CHECKOUT_PAGE_CLICK_EVENTS];

interface LoggingParams {
  componentName: CheckoutStepName;
  additionalParameters: any;
}

const onCheckoutPageView = ({
  name,
  trackingData,
}: {
  name: CheckoutStepName;
  trackingData: any;
}) => {
  if (!trackingData) {
    return;
  }

  const index = CHECKOUT_STEP_MAP[name];
  if (index === undefined) {
    console.warn(`Invalid index for step ${name}!`);
  }

  const { order, products } = trackingData;

  products.forEach((p) => trackGA('ec:addProduct', 'checkoutV3', p));
  trackGA('ec:setAction', 'checkoutV3', { step: index });
  if (name === COMPONENT_NAMES.APPS.CHECKOUT_V3.ORDER_COMPLETE) {
    trackGA('ec:setAction', 'checkoutV3', 'purchase', order);
  }

  trackEvent({
    name: 'Checkout',
    value: `Step ${index}: ${name}`,
    params: order,
  });

  trackCdp({
    name: 'View Checkout Step',
    params: {
      feature: 'shop',
      step: name,
      ...trackingData,
    },
  });
};

const onCheckoutPageViewV2 = ({
  componentName,
  additionalParameters,
}: LoggingParams) => {
  trackViewFeature({
    componentName,
    eventDescription: `Viewed ${componentName}`,
    additionalParameters,
  });
};

const onCheckoutPageViewCombined = ({
  componentName,
  additionalParameters,
}: LoggingParams) => {
  onCheckoutPageView({
    name: componentName,
    trackingData: additionalParameters,
  });
  onCheckoutPageViewV2({
    componentName,
    additionalParameters,
  });
};

const onCheckoutPageClick = ({
  eventDesc,
  trackingData,
  additionalDetails = {},
  componentName,
  actionItem,
  subActionItem,
}: {
  eventDesc: CheckoutPageClickEvent;
  trackingData: any;
  additionalDetails?: any;
  componentName?: CheckoutStepName;
  actionItem?: string;
  subActionItem?: string;
}) => {
  trackCdp({
    name: 'Complete Checkout Step',
    params: {
      feature: 'shop',
      step: eventDesc,
      ...trackingData,
    },
  });

  trackClickFeature({
    componentName,
    eventDescription: eventDesc,
    actionItem,
    subActionItem,
    additionalParameters: {
      ...additionalDetails,
      ...trackingData,
    },
  });

  trackCheckoutClick(eventDesc, trackingData.order, additionalDetails);
};

export {
  CheckoutStepName,
  onCheckoutPageView,
  onCheckoutPageViewV2,
  onCheckoutPageViewCombined,
  onCheckoutPageClick,
};
